module.exports = __webpack_public_path__ + "6ecd0780465518dc751a8fde9803ff45.pdf";